import { render } from "./AttendanceRegisterModal.vue?vue&type=template&id=5e478cdd"
import script from "./AttendanceRegisterModal.vue?vue&type=script&lang=js"
export * from "./AttendanceRegisterModal.vue?vue&type=script&lang=js"

import "./AttendanceRegisterModal.vue?vue&type=style&index=0&id=5e478cdd&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__